export default __webpack_public_path__ + "static/media/webmoney.ef15e470.svg";